module.exports = __webpack_public_path__ + "img/emoticon-csat-4-on.908b4d04.svg";